import { Activity, Duty } from '../backend/backendapi';

export function getCheckListJson(activity: Activity, duty: Duty):string {
  if (activity.jsonVMChecklist) { // take the checklist already saved in the activity
    return activity.jsonVMChecklist;
  } else if (duty.checklists?.length) {
    return duty.checklists[0].json ?? '[]';
  } else {
    return '[]';
  }
}